import { Card, Flex, Typography } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { brandRamp, status } from '../theme';

interface Props {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  tone?: 'default' | 'danger' | 'warning' | 'success';
  to?: string;
}

const tones = {
  default: { bg: brandRamp[160], fg: brandRamp[80] },
  danger: { bg: status.dangerBg, fg: status.dangerText },
  warning: { bg: status.warningBg, fg: status.warningText },
  success: { bg: status.successBg, fg: status.successText },
};

/** A key figure with its label and a one-line hint; clickable when it leads to the list behind it. */
export function StatCard({ label, value, hint, icon, tone = 'default', to }: Props) {
  const body = (
    <Card hoverable={Boolean(to)} style={{ height: '100%' }} styles={{ body: { padding: 16 } }}>
      <Flex justify="space-between" align="flex-start">
        <div>
          <Typography.Text type="secondary">{label}</Typography.Text>
          <div style={{ fontSize: 28, fontWeight: 600, lineHeight: '36px', marginTop: 4 }}>
            {value}
          </div>
          {hint && (
            <Typography.Text
              type="secondary"
              style={{ fontSize: 12, display: 'block', marginTop: 4 }}
            >
              {hint}
            </Typography.Text>
          )}
        </div>
        {icon && (
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              display: 'grid',
              placeItems: 'center',
              background: tones[tone].bg,
              color: tones[tone].fg,
              fontSize: 18,
            }}
          >
            {icon}
          </div>
        )}
      </Flex>
    </Card>
  );
  return to ? <Link to={to}>{body}</Link> : body;
}
